import * as React from 'react';
import withTranslate, { WithTranslateProps } from './WithTranslate';
import SimplePharmacyCalendar from './SimplePharmacyCalendar';
import { MultiCalendarSelectionType } from './MultiCalendar';
import { AuthenticationStore } from '../../store/AuthenticationStore';
import { Instance } from 'mobx-state-tree';
import { inject } from 'mobx-react';
import { PharmacyStore, SecretariatStore } from '../../store';

export interface MultiCalendarForComparisonProps extends WithTranslateProps {
  dummy?: number;
  startingPharmacy?: number;
  startingSecondPharmacy?: number;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
}

export interface MultiCalendarForComparisonState {
  isOpen: boolean;
  selectedYear?: number;
  selectedType?: MultiCalendarSelectionType;
}

@inject('AuthenticationStore')
@inject('PharmacyStore')
@inject('SecretariatStore')
class MultiCalendarForComparison extends React.Component<
  MultiCalendarForComparisonProps,
  MultiCalendarForComparisonState
> {
  state = {
    isOpen: false,
    selectedYear: new Date().getFullYear(),
    selectedType: undefined,
  } as MultiCalendarForComparisonState;

  async componentDidMount() {
    this.props.SecretariatStore!.checkListLoaded();
    this.props.PharmacyStore!.checkListLoaded();
  }

  onTypeChange = (type: MultiCalendarSelectionType) => {
    if (this.state.selectedType !== type) {
      this.setState({ selectedType: type });
    }
  };

  onCalendarMove = (fly: number, sly: number) => {
    if (this.state.selectedYear !== fly) {
      this.setState({ selectedYear: fly });
    }
  };

  private getSecretariat = () => {
    let secretariatId = 1;
    if (this.props.AuthenticationStore!.isSuperAdmin) {
      secretariatId = this.props.SecretariatStore!.selectedSecretariatId;
    } else if (
      this.props.AuthenticationStore!.isSecretariat &&
      this.props.AuthenticationStore!.secretariatId !== null
    ) {
      secretariatId = this.props.AuthenticationStore!.secretariatId;
    }

    if (this.props.AuthenticationStore!.isPharmacy && this.props.AuthenticationStore!.pharmacyId !== null) {
      const pharmacy = this.props!.PharmacyStore!.getById(this.props.AuthenticationStore!.pharmacyId);
      if (pharmacy !== undefined && pharmacy.secretariatId !== undefined) {
        secretariatId = pharmacy.secretariatId;
      }
    }
    const secretariat = this.props.SecretariatStore!.getById(secretariatId);
    return secretariat;
  };

  render() {
    const secretariatId = this.getSecretariat()!.secretariatId;
    const startingPharmacy: number =
      this.props.PharmacyStore!.dataList.find((p) => p.secretariatId === secretariatId) !== undefined
        ? this.props.PharmacyStore!.dataList.find((p) => p.secretariatId === secretariatId)!.pharmacyId
        : 1;
    const startingSecondPharmacy: number =
      this.props.PharmacyStore!.dataList.find((p) => p.secretariatId === secretariatId) !== undefined
        ? this.props.PharmacyStore!.dataList.find((p) => p.secretariatId === secretariatId)!.pharmacyId
        : 1;
    return (
      <div>
        <SimplePharmacyCalendar
          id={'topCal'}
          pharmacyId={startingPharmacy}
          hideLegend={true}
          synchronizedScrolling={true}
          fly={this.state.selectedYear}
          onCalendarMove={this.onCalendarMove}
          onTypeChange={this.onTypeChange}
          selectedType={this.state.selectedType}
          separateToolbox={true}
          inMultiCalendar={true}
        />
        <SimplePharmacyCalendar
          id={'bottomCal'}
          pharmacyId={startingSecondPharmacy}
          hideLegend={true}
          synchronizedScrolling={true}
          fly={this.state.selectedYear}
          onCalendarMove={this.onCalendarMove}
          onTypeChange={this.onTypeChange}
          selectedType={this.state.selectedType}
          inMultiCalendar={true}
        />
        <div id={'anchor'} ref="anchor" />
      </div>
    );
  }
}

export default withTranslate(MultiCalendarForComparison);
